import { Component, OnInit } from '@angular/core'
import { CmsProductReferencesComponent, ProductReferenceService } from '@spartacus/core'
import {
  BREAKPOINT,
  BreakpointService,
  CmsComponentData,
  CurrentProductService,
  ProductReferencesComponent
} from '@spartacus/storefront'
import { UserPermissionService } from '../../../../services/user-permission/user-permission.service'

@Component({
    selector: 'app-custom-product-references',
    templateUrl: './custom-product-references.component.html',
    styleUrls: ['./custom-product-references.component.scss'],
    standalone: false
})
export class CustomProductReferencesComponent extends ProductReferencesComponent implements OnInit {
  constructor(
    protected cmsComponentData: CmsComponentData<CmsProductReferencesComponent>,
    protected currentProductService: CurrentProductService,
    protected productReferenceService: ProductReferenceService,
    private breakpointService: BreakpointService,
    public userPermissionService: UserPermissionService
  ) {
    super(cmsComponentData, currentProductService, productReferenceService)
  }

  public carouselWidth: string = '25%'

  ngOnInit(): void {
    this.breakpointService.breakpoint$.pipe().subscribe((pageSize) => {
      if (pageSize === BREAKPOINT.lg || pageSize === BREAKPOINT.xl) {
        this.carouselWidth = '285px'
      }
      if (pageSize === BREAKPOINT.md) {
        this.carouselWidth = '285px'
      }
      if (pageSize === BREAKPOINT.xs) {
        this.carouselWidth = '300px'
      }
    })
  }
}
